import { Call } from '../../../utils/multicall'
import {
  getAaveAssets,
  getAaveTypePoolDataProviderAddress,
} from '../../../assets'

const getBaseAaveV2Calls = (
  chainId: string,
  account: string,
  lender: string,
  assetsToQuery: string[],
) => {
  return assetsToQuery.flatMap((tk) => [
    {
      address: getAaveTypePoolDataProviderAddress(chainId, lender),
      name: 'getUserReserveData',
      params: [tk, account],
    },
  ])
}

export const buildAaveV2UserCall = (
  chainId: string,
  lender: string,
  account: string,
): Call[] => {
  switch (lender) {
    default: {
      const assetsToQuery = getAaveAssets(chainId, lender).sort((a, b) =>
        a.toLowerCase().localeCompare(b.toLowerCase()),
      )
      return getBaseAaveV2Calls(chainId, account, lender, assetsToQuery)
    }
  }
}
